"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var prop_types_1 = __importDefault(require("prop-types"));
var Button_1 = __importDefault(require("react-bootstrap/Button"));
var Loading_1 = __importDefault(require("../util/Loading"));
var Button = function (props) {
    var show = props.show, type = props.type, loading = props.loading, disabled = props.disabled, id = props.id, block = props.block, href = props.href, size = props.size, wide = props.wide, classes = props.classes, children = props.children;
    var onClick = function (e) {
        if (props.onClick) {
            props.onClick(e);
        }
    };
    return (react_1.default.createElement(Button_1.default, { size: size, variant: type, disabled: disabled || loading ? true : false, className: classnames_1.default(!show ? 'd-none' : undefined, wide ? 'btn-wide' : '', classes), onClick: onClick, block: block, href: href, id: id },
        react_1.default.createElement("div", { style: { position: 'relative' } },
            react_1.default.createElement("div", { style: { opacity: loading ? '0.3' : '1' } }, children),
            react_1.default.createElement("div", { className: classnames_1.default(loading ? undefined : 'd-none'), style: { position: 'absolute', top: '0px' } },
                react_1.default.createElement(Loading_1.default, null)))));
};
exports.Button = Button;
Button.TYPE_DEFAULT = 'default';
Button.TYPE_PRIMARY = 'primary';
Button.TYPE_SECONDARY = 'secondary';
Button.propTypes = {
    size: prop_types_1.default.any,
    show: prop_types_1.default.bool,
    loading: prop_types_1.default.bool,
    type: prop_types_1.default.string,
    onClick: prop_types_1.default.func,
    disabled: prop_types_1.default.bool,
    block: prop_types_1.default.bool,
    id: prop_types_1.default.string,
    href: prop_types_1.default.string,
    wide: prop_types_1.default.bool,
    classes: prop_types_1.default.string,
};
Button.defaultProps = {
    show: true,
    type: Button.TYPE_PRIMARY,
    loading: false,
};
exports.default = Button;
Button.displayName = 'Button';
//# sourceMappingURL=Button.js.map